import { render, staticRenderFns } from "./site-closure-banner.vue?vue&type=template&id=62ea28ab&scoped=true"
import script from "./site-closure-banner.vue?vue&type=script&lang=js"
export * from "./site-closure-banner.vue?vue&type=script&lang=js"
import style0 from "./site-closure-banner.vue?vue&type=style&index=0&id=62ea28ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ea28ab",
  null
  
)

export default component.exports